import { getConfig } from "../../reducers/portalConfig";
import * as constants from "../../constants";
import { getValidationErrors } from "../../utils";
import axios from "axios";

export const fetchAppearanceThemes = (orgUuid) =>
  async (dispatch, getState) => {
    dispatch({
      type: constants.APPEARANCE_THEMES_REQUEST,
      payload: true,
    });

    const headers = orgUuid ? { 'APIM-OrgUuid': orgUuid } : {};
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/branding/1.0/themes`;

    await axios.get(url, { credentials: 'include', headers })
      .then((response) => {
        dispatch({
          type: constants.APPEARANCE_THEMES_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.APPEARANCE_THEMES_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const updateAppearanceThemes = (payload, orgUuid) =>
  async (dispatch, getState) => {
    dispatch({
      type: constants.UPDATE_APPEARANCE_THEMES_REQUEST,
      payload: true,
    });

    const headers = orgUuid ? { 'APIM-OrgUuid': orgUuid } : {};
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/branding/1.0/themes`;
    await axios.put(url, payload, { credentials: 'include', headers })
      .then(() => {
        dispatch({
          type: constants.UPDATE_APPEARANCE_THEMES_SUCCESS,
          payload: constants.SUCCESS,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.UPDATE_APPEARANCE_THEMES_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const resetAppearanceThemes = (orgUuid) =>
  async (dispatch, getState) => {
    dispatch({
      type: constants.RESET_APPEARANCE_THEMES_REQUEST,
      payload: true,
    });

    const headers = {
      'APIM-OrgUuid': orgUuid,
    }

    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/branding/1.0/themes/reset`;

    await axios.post(url, "", { headers: orgUuid !== undefined ? headers : "" })
      .then(() => {
        dispatch({
          type: constants.RESET_APPEARANCE_THEMES_SUCCESS,
          payload: constants.SUCCESS,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.RESET_APPEARANCE_THEMES_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };